import React from 'react'
import { useNavigate } from 'react-router-dom'

import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

import { useContextHook } from '../../store/context'
import { setCurrentCustomer, setCurrentMachine } from '../../store/actions'
import { Customer } from '../../types/customer'
import NavButton from './navMenuButton'

const CustomerSelector = (): JSX.Element => {
  const navigate = useNavigate()
  const { dispatch, state } = useContextHook()
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = (): void => {
    setAnchorEl(null)
  }

  const onSelectCustomer = (customer: Customer): void => {
    const resetMachine = true
    dispatch(setCurrentCustomer(customer, resetMachine))
    dispatch(setCurrentMachine(null))
    navigate('/')
    handleCloseMenu()
  }

  return (
    <>
      <NavButton onClick={handleOpenMenu}>{state.currentCustomer?.name}</NavButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
        {state.user?.customers.map((customer) => (
          <MenuItem key={customer.id} onClick={() => onSelectCustomer(customer)}>
            {customer.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default CustomerSelector
